import React from 'react';

/**
 * URL regex pattern to match http/https URLs
 */
const URL_REGEX = /(https?:\/\/[^\s]+)/g;

/**
 * Parses text content and converts URLs to clickable links
 * @param text - Text content that may contain URLs
 * @returns React nodes with parsed links
 */
export const parseTextWithLinks = (text: string): React.ReactNode => {
  if (!text) return text;

  const parts = text.split(URL_REGEX);

  return parts.map((part, idx) => {
    // Check if this part is a URL
    if (part.match(URL_REGEX)) {
      return (
        <a
          key={idx}
          href={part}
          target="_blank"
          rel="noopener noreferrer"
          className="text-blue-500 hover:text-blue-700 underline"
        >
          {part}
        </a>
      );
    }

    return part;
  });
};
